import actions from './flow/actions';
import mutations from './flow/mutations';
import getters from './flow/getters';

// Article State
const state = {
  // indexFlowTags: [],
  // indexFlowType: 'scoop',
  // indexFilterType: 'date',
  // indexFlowArticle: null,
  // indexFlowScoop: null,
  // indexFlowResume: null,
  // indexFlowQa: null,

  indexOverviewMode: 'overview',

  postValue: null,
  postErrorText: '',
  postCheckPass: false,
  postBasicOption: [],
  postCoreOption: [],
};

export default {
  state,
  actions,
  mutations,
  getters,
  namespaced: true,
  strict: true,
};
